import { commonDate, removeNull, removeHtmlTags, truncateText } from 'src/helpers'
import endpoint from 'src/store/modules/endpoint'

export const skuMainTable = {
  columns: [
    {
      name: 'name',
      field: row => {
        return `
        <div class="text-no-wrap">
          <a
            href="/sku/form/preview/${row.id}/${encodeURIComponent(row.product_name.replace(/[./_()]/g, ' '))}"
            class="goto-preview-page q-mr-xs"
          >
            ${row.product_name}
          </a>
          ${
            !row.is_ppn
              ? '<span role="alert" class="custom-badge-blue dense">Bebas PPN</span>'
              : ''
          }
        </div>
        <span>${row.sku || '-'}</span>
        `
      },
      label: 'Nama SKU',
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'kategori_1_name',
      field: 'kategori_1_name',
      label: 'Kategori 1',
      sortable: false,
      align: 'left',
      rowClass: 'td-no-wrap'
    },
    {
      name: 'kategori_2_name',
      field: 'kategori_2_name',
      label: 'Kategori 2',
      sortable: false,
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'kategori_3_name',
      field: 'kategori_3_name',
      label: 'Kategori 3',
      sortable: false,
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'brand_name',
      field: 'brand_name',
      label: 'Merek',
      sortable: false,
      align: 'left'
    },
    {
      name: 'varian',
      field: (row) => {
        return row.variantCount > 1
          ? '<div role="alert" class="custom-badge-green dense">Ada</div>'
          : '<div role="alert" class="custom-badge-red dense">Tidak Ada</div>'
      },
      label: 'Varian Produk',
      sortable: true,
      align: 'left'
    },
    {
      name: 'dimension',
      field: row => {
        return `${row.length}x${row.width}x${row.height}`
      },
      label: 'Dimensi (PxLxT)',
      sortable: true,
      rowClass: 'text-right'
    },
    {
      name: 'unit_name',
      field: 'unit_name',
      label: 'Satuan',
      sortable: true,
      align: 'left'
    },
    {
      name: 'created_at',
      field: 'created_at',
      label: 'Tanggal Dibuat',
      sortable: true,
      align: 'left',
      commonDate: true
    },
    {
      name: 'create_by',
      field: row => {
        return `${
          {
            JV: `<div class="custom-badge-green dense">
              <img src="${require('src/assets/images/icons/16x16-laptop.svg')}"/>
              JV
              </div>`,
            null: `<div class="custom-badge-purple dense">
              <img src="${require('src/assets/images/icons/12x12-user-purple.svg')}"/>
              CMS
            </div>`
          }[row.product_origin]
        }
        <div>${row.created_by || '-'}</div>
        `
      },
      label: 'Dibuat Oleh',
      align: 'left'
    },
    {
      name: 'deleted_at',
      field: 'deleted_at',
      label: 'Tanggal Nonaktif',
      sortable: true,
      align: 'left',
      commonDate: true
    }
  ]
}

export const skuSubmissionTable = {
  columns: [
    {
      name: 'name',
      field: (row) => {
        return `
          <div class="column items-start">
            <strong>${row.name}</strong>
            ${row.is_ppn ? '' : '<div role="alert" class="custom-badge custom-badge-blue q-mt-xs">Bebas PPN</div>'}
          </div>
        `
      },
      label: 'Nama Produk',
      sortable: true,
      align: 'left',
      rowClass: 'text-primary'
    },
    {
      name: 'item_category_name',
      field: (row) => {
        return row.item_category_name || '-'
      },
      label: 'Kategori',
      sortable: false,
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'brand_name',
      field: (row) => {
        return row.brand_name || '-'
      },
      label: 'Merek',
      sortable: false,
      align: 'left'
    },
    {
      name: 'supplier_name',
      field: (row) => {
        return row.supplier_name || '-'
      },
      label: 'Vendor Pemohon',
      sortable: false,
      align: 'left'
    },
    {
      name: 'created_at',
      field: 'created_at',
      label: 'Tanggal Pengajuan',
      sortable: true,
      align: 'left',
      commonDate: true
    },
    {
      name: 'processed_at',
      field: 'processed_at',
      label: 'Tanggal Diproses',
      sortable: true,
      align: 'left',
      commonDate: true
    },
    {
      name: 'product_add_status',
      field: (row) => {
        const badge = {
          ACCEPTED: ['custom-badge-green', 'Sudah Dibuat'],
          WAITING: ['custom-badge-purple', 'Belum Diproses']
        }[row.product_add_status] || ['custom-badge-red q-mb-xs', 'Ditolak']

        return `<div class="text-center">
          <div role="alert" class="custom-badge ${badge[0]}">${badge[1]}</div>
        </div>`
      },
      label: 'Status',
      sortable: true,
      align: 'center'
    }
  ]
}

export const skuMarginHistory = {
  columns: [
    {
      name: 'created_at',
      required: true,
      label: 'Tanggal',
      align: 'left',
      field: row => commonDate({
        useDayName: true,
        date: row.created_at,
        useTime: true
      }),
      sortable: true,
      commonDate: true
    },
    {
      name: 'margin_retail',
      required: true,
      label: 'Retail',
      align: 'left',
      field: row => row.margin_retail + '%',
      sortable: true
    },
    {
      name: 'margin_business',
      required: true,
      label: 'Bisnis',
      align: 'left',
      field: row => row.margin_business + '%',
      sortable: true
    }
  ]
}
const gotoCategoryDetail = (row, type) => {
  return encodeURIComponent(
    JSON.stringify({
      name: 'sku-category-form-fields',
      params: {
        action: 'preview',
        categoryNumber: type,
        id: row['cat' + type + '_id'],
        name: row['cat' + type + '_slug']
      },
      query: removeNull({
        categoryId: {
          2: row.cat1_id,
          3: row.cat2_id
        }[type] || null,
        categoryName1: {
          2: row.cat1_name,
          3: row.cat1_name
        }[type] || null,
        categoryName2: {
          3: row.cat2_name
        }[type] || null
      })
    })
  )
}

export const skuCategoryMainTable = {
  api: endpoint.state.categoryList,
  exportApi: endpoint.state.category1,
  columns: [
    {
      name: 'kategori3',
      field: row => {
        return row.cat3_name
          ? `<strong
              router-push="${gotoCategoryDetail(row, 3)}"
            >${row.cat3_name}</strong>`
          : '-'
      },
      label: 'Kategori 3',
      sortable: false,
      align: 'center',
      rowClass: 'text-center text-capitalize'
    },
    {
      name: 'kategori2',
      field: row => {
        return row.cat2_name
          ? `<strong
              router-push="${gotoCategoryDetail(row, 2)}"
            >${row.cat2_name}</strong>`
          : '-'
      },
      label: 'Kategori 2',
      sortable: false,
      align: 'center',
      rowClass: 'text-center'
    },
    {
      name: 'kategori1',
      field: row => {
        return row.cat1_name
          ? `<strong
              router-push="${gotoCategoryDetail(row, 1)}"
            >${row.cat1_name}</strong>`
          : '-'
      },
      label: 'Kategori 1',
      sortable: false,
      align: 'center',
      rowClass: 'text-center'
    },
    {
      name: 'retail',
      field: (row) => {
        return row.cat3_margin_retail
          ? row.cat3_margin_retail + '%'
          : '-'
      },
      label: 'Retail',
      sortable: false,
      align: 'center',
      rowClass: 'text-center text-capitalize'
    },
    {
      name: 'bisnis',
      field: (row) => {
        return row.cat3_margin_business
          ? row.cat3_margin_business + '%'
          : '-'
      },
      label: 'Bisnis',
      sortable: false,
      align: 'center',
      rowClass: 'text-center text-capitalize'
    },
    {
      name: 'deskripsi',
      field: (row) => {
        const cleanText = removeHtmlTags(row.cat3_description)
        return row.cat3_description
          ? truncateText(cleanText, 150)
          : '-'
      },
      label: 'Deskripsi',
      sortable: false,
      align: 'center',
      rowClass: 'text-center text-capitalize max-width-300'
    }
  ]
}
